import {
  getAllProjects,
} from '../api/lemon';


  // eslint-disable-next-line import/prefer-default-export
export async function getAllHelpProjects() {
  const allTags = await getAllProjects();
  return allTags.sort((a, b) => a.project_lemon_tag.localeCompare(b.project_lemon_tag));
}
